// extracted by mini-css-extract-plugin
module.exports = {"input":"input__1ISNw","label":"label__3bvHV"};